import { render, staticRenderFns } from "./AddMarque.vue?vue&type=template&id=2db19a8a&"
import script from "./AddMarque.vue?vue&type=script&lang=js&"
export * from "./AddMarque.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports